import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as projectReducer from "containers/Project/reducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as globalReducer from "containers/App/reducer";
import * as viewReducer from "containers/View/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";

import DeploySettings from "components/Next/Deploy/DeploySettings";

class DeploySettingsContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <DeploySettings {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps?.nextId;

  return {
    deploy: (projectId) => dispatch(projectReducer.deploy(projectId, true)),
    viewScenario: (projectId, scenario, index) => dispatch(projectReducer.viewScenario(projectId, scenario, index)),
    deleteScenario: (projectId) => dispatch(projectReducer.deleteScenario(projectId)),

    saveScenario: (projectId, name) => dispatch(projectReducer.saveScenario(projectId, name)),

    updateIsOpenScenarioSave: (isOpen) => dispatch(nextReducer.updateIsOpenSaveScenarioModal(id, isOpen))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = ownProps?.nextId;
  const projectId = nextReducer.getProjectId(state, id);

  const optimized = projectReducer.getOptimized(state, projectId);

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  return {
    projectId,

    isSavingScenario: nextReducer.getIsSavingScenario(state, id),

    selectedScenario: projectReducer.getSelectedScenario(state, projectId),
    allScenarios: projectReducer.getAllScenarios(state, projectId),
    approvedScenario: projectReducer.getApprovedScenario(state, projectId, runId),
    hasSameScenario: projectReducer.getHasSameScenario(state, projectId),
    deployment: deploymentsReducer.getProjectDeployment(state, projectId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DeploySettingsContainer);
